<template>
    <h1 class="h3 mb-3 fw-normal"><slot/></h1>
</template>
